module.exports = __webpack_public_path__ + "img/vouchers15010.8017c4ec.png";